export const FREQ4 = ["Mai", "Alcuni giorni", "Più della metà dei giorni", "Quasi ogni giorno"];
export const FREQ5 = ["Mai", "Raramente", "A volte", "Spesso", "Molto spesso"];
export const AGREE4 = ["Decisamente d'accordo", "Abbastanza d'accordo", "Abbastanza in disaccordo", "Decisamente in disaccordo"];
export const CBI_FREQ = ["Sempre", "Spesso", "Qualche volta", "Raramente", "Mai"];

const GAD7_QUESTIONS = [
  "Hai provato nervosismo, ansia o una forte tensione?",
  "Hai avuto difficoltà a smettere di preoccuparti o a tenere sotto controllo le preoccupazioni?",
  "Hai provato una preoccupazione eccessiva per diverse cose?",
  "Hai avuto difficoltà a rilassarti?",
  "Hai avvertito un'irrequietezza così intensa da avere difficoltà a stare fermi?",
  "Hai provato irritazione o fastidio con facilità?",
  "Hai avuto paura che potesse accadere qualcosa di terribile?",
];

const PHQ9_QUESTIONS = [
  "Scarso interesse o piacere nel fare le cose.",
  "Sentirsi giù, depressi o senza speranza.",
  "Difficoltà ad addormentarti o a mantenere il sonno, oppure dormire troppo.",
  "Sentirsi stanchi o avere poca energia.",
  "Scarso appetito oppure mangiare troppo.",
  "Avere una cattiva opinione di sé, sentirsi un fallimento oppure pensare di aver deluso se stessi o la propria famiglia.",
  "Difficoltà a concentrarti, per esempio nel leggere o guardare la televisione.",
  "Muoversi o parlare così lentamente che altre persone potrebbero accorgersene, oppure, al contrario, sentirsi così agitati o irrequieti da muoversi molto più del solito.",
  "Pensare che sarebbe meglio essere morti oppure pensare di farsi del male.",
];

const ASRS_QUESTIONS = [
  "Quante volte hai difficoltà a portare a termine i dettagli finali di un progetto, una volta che le parti più impegnative sono state completate?",
  "Quante volte hai difficoltà a organizzarti quando devi svolgere un compito che richiede organizzazione?",
  "Quante volte hai problemi a ricordare appuntamenti od obblighi?",
  "Quando hai un compito che richiede molta concentrazione, quante volte eviti o rimandi l'inizio?",
  "Quante volte ti agiti o giocherelli con le mani o con i piedi quando devi rimanere seduti a lungo?",
  "Quante volte avverti un'eccessiva attivazione e la sensazione di dover fare delle cose, come se ti guidasse un motore?",
  "Quante volte commetti errori di disattenzione quando lavori a un progetto noioso o difficile?",
  "Quante volte hai difficoltà a mantenere l'attenzione quando svolgi un lavoro noioso o ripetitivo?",
  "Quante volte hai difficoltà a concentrarti su ciò che ti dicono le persone, anche quando ti stanno parlando direttamente?",
  "Quante volte perdi o hai difficoltà a trovare oggetti a casa o al lavoro?",
  "Quante volte attività o rumori intorno a te ti distraggono?",
  "Quante volte lasci il tuo posto durante riunioni o in altre situazioni in cui è previsto di rimanere seduti?",
  "Quante volte avverti irrequietezza o agitazione?",
  "Quante volte hai difficoltà a rilassarti quando hai del tempo libero per te?",
  "Quante volte ti accorgi di parlare troppo in situazioni sociali?",
  "Quando sei in una conversazione, quante volte finisci le frasi delle persone che stanno parlando, prima che loro possano finirle?",
  "Quante volte hai difficoltà ad attendere il tuo turno in situazioni in cui è richiesto?",
  "Quante volte interrompi gli altri quando sono occupati?",
];

// Part A = items 0-5; soglie ufficiali ASRS: item 1-3 positivi da "A volte", item 4-6 positivi da "Spesso"
const ASRS_PARTA_THRESHOLDS = [2, 2, 2, 3, 3, 3];

// AQ-50 (versione italiana). key "A" = punteggio se d'accordo; "D" = punteggio se in disaccordo
const AQ_ITEMS = [
  { q: "Preferisco fare le cose con gli altri piuttosto che in solitudine.", key: "D" },
  { q: "Preferisco fare le cose sempre allo stesso modo, ripetutamente.", key: "A" },
  { q: "Se provo a immaginare qualcosa, mi è molto facile creare un'immagine nella mia mente.", key: "D" },
  { q: "Spesso mi capita di assorbirmi così tanto in una cosa da perdere di vista le altre.", key: "A" },
  { q: "Spesso noto piccoli rumori che gli altri non notano.", key: "A" },
  { q: "Di solito faccio attenzione ai numeri di targa delle auto o a simili sequenze di informazioni.", key: "A" },
  { q: "Le altre persone spesso mi dicono che ciò che ho detto è scortese, anche quando secondo me è cortese.", key: "A" },
  { q: "Quando leggo un racconto, riesco facilmente a immaginare l'aspetto dei personaggi.", key: "D" },
  { q: "Le date mi affascinano.", key: "A" },
  { q: "In un gruppo sociale, riesco facilmente a seguire le conversazioni di diverse persone contemporaneamente.", key: "D" },
  { q: "Trovo facili le situazioni sociali.", key: "D" },
  { q: "Tendo a notare dettagli che gli altri non notano.", key: "A" },
  { q: "Preferirei andare in biblioteca piuttosto che a una festa.", key: "A" },
  { q: "Trovo facile inventare storie.", key: "D" },
  { q: "Le persone mi attraggono più delle cose.", key: "D" },
  { q: "Tendo ad avere interessi molto intensi e mi rattristo se non posso coltivarli.", key: "A" },
  { q: "Mi piace conversare del più e del meno.", key: "D" },
  { q: "Quando parlo, non è sempre facile per gli altri inserirsi nella conversazione.", key: "A" },
  { q: "I numeri mi affascinano.", key: "A" },
  { q: "Quando leggo un racconto, trovo difficile capire le intenzioni dei personaggi.", key: "A" },
  { q: "Non mi piace particolarmente leggere narrativa.", key: "A" },
  { q: "Trovo difficile fare nuove amicizie.", key: "A" },
  { q: "Noto continuamente degli schemi nelle cose.", key: "A" },
  { q: "Preferirei andare a teatro piuttosto che al museo.", key: "D" },
  { q: "Non mi turba se la mia routine quotidiana viene sconvolta.", key: "D" },
  { q: "Mi capita spesso di non sapere come portare avanti una conversazione.", key: "A" },
  { q: 'Trovo facile "leggere tra le righe" quando qualcuno mi parla.', key: "D" },
  { q: "Di solito mi concentro più sull'immagine complessiva che sui piccoli dettagli.", key: "D" },
  { q: "Ricordare i numeri di telefono non è il mio forte.", key: "D" },
  { q: "Di solito non noto piccoli cambiamenti in una situazione o nell'aspetto di una persona.", key: "D" },
  { q: "So capire se una persona che mi ascolta si sta annoiando.", key: "D" },
  { q: "Trovo facile fare più di una cosa contemporaneamente.", key: "D" },
  { q: "Quando parlo al telefono, non mi è chiaro quando sia il mio turno per parlare.", key: "A" },
  { q: "Mi piace fare le cose spontaneamente.", key: "D" },
  { q: "Spesso sono l'ultima persona a capire la battuta di una barzelletta.", key: "A" },
  { q: "Trovo facile capire cosa qualcuno sta pensando o provando semplicemente guardando il suo viso.", key: "D" },
  { q: "Se c'è un'interruzione, riesco a tornare rapidamente a ciò che stavo facendo.", key: "D" },
  { q: "Le conversazioni sociali leggere mi riescono bene.", key: "D" },
  { q: "Le persone spesso mi dicono che parlo sempre delle stesse cose.", key: "A" },
  { q: "Nell'infanzia mi piaceva giocare con gli altri bambini a giochi di finzione.", key: "D" },
  { q: "Mi piace raccogliere informazioni su categorie di cose (per esempio tipi di auto, uccelli, treni, piante).", key: "A" },
  { q: "Trovo difficile immaginare cosa significhi essere qualcun altro.", key: "A" },
  { q: "Mi piace pianificare con cura ogni attività a cui partecipo.", key: "A" },
  { q: "Mi piacciono le occasioni sociali.", key: "D" },
  { q: "Trovo difficile capire le intenzioni delle persone.", key: "A" },
  { q: "Le situazioni nuove mi provocano ansia.", key: "A" },
  { q: "Mi piace conoscere persone nuove.", key: "D" },
  { q: "Sono una persona diplomatica.", key: "D" },
  { q: "Ricordare le date di nascita delle persone non è il mio forte.", key: "D" },
  { q: "Trovo molto facile giocare con i bambini a giochi di finzione.", key: "D" },
];

const CBI_SECTIONS = [
  {
    id: "personal",
    label: "Burnout personale",
    questions: [
      "Quante volte avverti stanchezza?",
      "Quante volte avverti esaurimento fisico?",
      "Quante volte avverti esaurimento emotivo?",
      'Quante volte pensi: "Non ce la faccio più"?',
      "Quante volte avverti una sensazione di logorio?",
      "Quante volte avverti debolezza e vulnerabilità alle malattie?",
    ],
  },
  {
    id: "work",
    label: "Burnout lavorativo",
    questions: [
      "Il tuo lavoro ti logora emotivamente.",
      "Avverti esaurimento a causa del tuo lavoro.",
      "Il tuo lavoro ti frustra.",
      "Avverti una sensazione di logorio alla fine della giornata lavorativa.",
      "Al mattino, al pensiero di un'altra giornata di lavoro, avverti già esaurimento.",
      "Senti che ogni ora di lavoro sia faticosa per te.",
      "Hai abbastanza energia per la famiglia e gli amici durante il tempo libero.",
    ],
    reversed: [6],
  },
  {
    id: "client",
    label: "Burnout correlato ai clienti/pazienti",
    questions: [
      "Ti risulta difficile lavorare con clienti/utenti/pazienti.",
      "Lavorare con clienti/utenti/pazienti ti frustra.",
      "Lavorare con clienti/utenti/pazienti ti scarica di energia.",
      "Senti di dare più di quanto ricevi quando lavori con clienti/utenti/pazienti.",
      "Avverti stanchezza nel lavorare con clienti/utenti/pazienti.",
      "Ti capita di chiederti per quanto tempo potrai continuare a lavorare con clienti/utenti/pazienti.",
    ],
  },
];

const CBI_VALUES = [100, 75, 50, 25, 0];

export const SCREENING_TESTS = [
  {
    id: "ansia",
    name: "ANSIA",
    testName: "GAD-7",
    meta: "7 domande · circa 2 minuti",
    color: { bg: "#FFFFFF", edge: "#DCE4EA" },
    introTitle: "Test Ansia Online",
    introSub: "Esegui il Test Ansia GAD-7",
    introText: "Questionario breve per valutare la presenza e la frequenza di sintomi ansiosi nelle ultime due settimane.",
    bullets: ["7 domande", "circa 2 minuti", "senza registrazione", "risultato immediato", "strumento di screening, non diagnostico"],
    reference: "Nelle ultime 2 settimane, con quale frequenza hai avuto i seguenti problemi?",
    options: FREQ4,
    questions: GAD7_QUESTIONS,
    emailLabel: "GAD-7 – Ansia",
    compute(answers) {
      const total = answers.reduce((a, b) => a + b, 0);
      const clinical = total <= 4 ? "minima" : total <= 9 ? "lieve" : total <= 14 ? "moderata" : "severa";
      const esito = total <= 4 ? "neg" : total <= 9 ? "inter" : "pos";
      return {
        esito,
        scoreLines: [`Punteggio: ${total}/21`],
        reportLines: [
          `Punteggio: ${total}/21`,
          `Esito screening: ${esito === "pos" ? "POSITIVO/ELEVATO" : esito === "inter" ? "INTERMEDIO" : "NEGATIVO/BASSO"}`,
          `Interpretazione: sintomatologia ansiosa di entità ${clinical}.`,
        ],
      };
    },
  },
  {
    id: "depressione",
    name: "DEPRESSIONE",
    testName: "PHQ-9",
    meta: "9 domande · circa 2 minuti",
    color: { bg: "#DCEEE4", edge: "#BFDCCC" },
    introTitle: "Test Depressione Online",
    introSub: "Esegui il PHQ-9",
    introText: "Questionario di 9 domande per valutare la presenza e la frequenza di sintomi depressivi nelle ultime due settimane.",
    bullets: ["9 domande", "circa 2 minuti", "senza registrazione", "risultato immediato", "strumento di screening, non diagnostico"],
    reference: "Nelle ultime 2 settimane, con quale frequenza hai avuto i seguenti problemi?",
    options: FREQ4,
    questions: PHQ9_QUESTIONS,
    emailLabel: "PHQ-9 – Depressione",
    compute(answers) {
      const total = answers.reduce((a, b) => a + b, 0);
      const clinical = total <= 4 ? "minima" : total <= 9 ? "lieve" : total <= 14 ? "moderata" : total <= 19 ? "moderatamente grave" : "grave";
      const esito = total <= 4 ? "neg" : total <= 9 ? "inter" : "pos";
      const item9 = answers[8] > 0;
      const reportLines = [
        `Punteggio: ${total}/27`,
        `Esito screening: ${esito === "pos" ? "POSITIVO/ELEVATO" : esito === "inter" ? "INTERMEDIO" : "NEGATIVO/BASSO"}`,
        `Interpretazione: sintomatologia depressiva di entità ${clinical}.`,
      ];
      if (item9) {
        reportLines.push("ATTENZIONE: item 9 PHQ-9 positivo.", `Risposta: ${FREQ4[answers[8]]}`);
      }
      return {
        esito,
        scoreLines: [`Punteggio: ${total}/27`],
        item9Alert: item9
          ? "Hai indicato la presenza di pensieri relativi alla morte o al farti del male. Ti consigliamo di parlarne tempestivamente con un professionista sanitario. Se ritieni di essere in pericolo immediato o temi di poter agire su questi pensieri, contatta subito i servizi di emergenza della tua zona."
          : null,
        reportLines,
      };
    },
  },
  {
    id: "adhd",
    name: "ADHD",
    testName: "ASRS-v1.1",
    meta: "18 domande · circa 3–4 minuti",
    color: { bg: "#F4F6F8", edge: "#D1D5DB" },
    introTitle: "Test ADHD Online per Adulti",
    introSub: "Esegui l'ASRS-v1.1",
    introText: "Questionario di screening per verificare la presenza di caratteristiche che possono essere compatibili con ADHD nell'adulto.",
    bullets: ["dai 16 anni", "18 domande", "circa 3–4 minuti", "senza registrazione", "strumento di screening, non diagnosi"],
    reference: "Negli ultimi 6 mesi, con quale frequenza ti sono capitate le seguenti situazioni?",
    options: FREQ5,
    questions: ASRS_QUESTIONS,
    emailLabel: "ASRS-v1.1 – ADHD adulto",
    compute(answers) {
      const partA = ASRS_PARTA_THRESHOLDS.filter((th, i) => answers[i] >= th).length;
      const esito = partA <= 2 ? "neg" : partA === 3 ? "inter" : "pos";
      return {
        esito,
        scoreLines: [`Parte A: ${partA}/6 item sopra soglia`],
        note:
          esito === "pos"
            ? "Il risultato dello screening evidenzia caratteristiche che possono essere compatibili con ADHD nell'adulto. Lo screening non permette da solo di formulare una diagnosi di ADHD, che richiede una valutazione clinica specialistica."
            : null,
        reportLines: [
          "ASRS-v1.1",
          `Parte A: ${partA}/6 item sopra soglia`,
          `Esito screening: ${esito === "pos" ? "POSITIVO" : esito === "inter" ? "INTERMEDIO" : "NEGATIVO"}`,
        ],
      };
    },
  },
  {
    id: "autismo",
    name: "AUTISMO",
    testName: "Autism-Spectrum Quotient – AQ",
    meta: "50 domande · circa 5–10 minuti",
    color: { bg: "#F6DEE3", edge: "#E8C4CD" },
    introTitle: "Test Autismo Online per Adulti",
    introSub: "Esegui l'Autism-Spectrum Quotient (AQ)",
    introText: "Questionario di screening che esplora caratteristiche e tratti associati allo spettro autistico.",
    bullets: ["50 domande", "circa 5–10 minuti", "senza registrazione", "risultato immediato", "strumento di screening, non diagnostico"],
    reference: "Indica quanto sei d'accordo con ciascuna affermazione.",
    options: AGREE4,
    questions: AQ_ITEMS.map((i) => i.q),
    emailLabel: "AQ – Autismo adulto",
    compute(answers) {
      let total = 0;
      AQ_ITEMS.forEach((item, i) => {
        const a = answers[i];
        if (item.key === "A" && (a === 0 || a === 1)) total += 1;
        if (item.key === "D" && (a === 2 || a === 3)) total += 1;
      });
      const esito = total <= 25 ? "neg" : total <= 31 ? "inter" : "pos";
      return {
        esito,
        scoreLines: [`Punteggio: ${total}/50`],
        note: "Un punteggio elevato non equivale a una diagnosi di disturbo dello spettro autistico. Se emergono caratteristiche significative, può essere indicata una valutazione specialistica più approfondita.",
        reportLines: [
          `AQ: ${total}/50`,
          `Esito screening: ${esito === "pos" ? "POSITIVO/ELEVATO" : esito === "inter" ? "INTERMEDIO" : "NEGATIVO/BASSO"}`,
        ],
      };
    },
  },
  {
    id: "burnout",
    name: "STRESS E BURNOUT",
    testName: "Copenhagen Burnout Inventory – CBI",
    meta: "19 domande · circa 3–5 minuti",
    color: { bg: "#E6DEF3", edge: "#CEC0E6" },
    introTitle: "Test Stress e Burnout",
    introSub: "Copenhagen Burnout Inventory – CBI",
    introText: "Questionario per esplorare la presenza di esaurimento e affaticamento associati alla vita personale e lavorativa.",
    bullets: ["19 domande", "circa 3–5 minuti", "senza registrazione", "risultato immediato", "strumento di screening"],
    reference: "Con quale frequenza ti capita quanto descritto?",
    options: CBI_FREQ,
    sections: CBI_SECTIONS,
    questions: CBI_SECTIONS.flatMap((s) => s.questions.map((q) => ({ q, section: s.label }))),
    emailLabel: "CBI – Stress/Burnout",
    compute(answers) {
      let offset = 0;
      const means = CBI_SECTIONS.map((sec) => {
        const vals = sec.questions.map((_, j) => {
          const idx = offset + j;
          const v = CBI_VALUES[answers[idx]];
          return sec.reversed && sec.reversed.includes(j) ? 100 - v : v;
        });
        offset += sec.questions.length;
        return Math.round(vals.reduce((a, b) => a + b, 0) / vals.length);
      });
      const overall = Math.round(means.reduce((a, b) => a + b, 0) / means.length);
      const esito = overall < 25 ? "neg" : overall < 50 ? "inter" : "pos";
      const scoreLines = [
        `Burnout personale: ${means[0]}/100`,
        `Burnout lavorativo: ${means[1]}/100`,
        `Burnout correlato alle persone assistite/clienti: ${means[2]}/100`,
      ];
      return {
        esito,
        scoreLines,
        note: "Le fasce sono utilizzate dalla web app come orientamento descrittivo e non costituiscono soglie diagnostiche.",
        reportLines: [
          `Burnout personale: ${means[0]}/100`,
          `Burnout lavorativo: ${means[1]}/100`,
          `Burnout correlato ai clienti/pazienti: ${means[2]}/100`,
          `Esito complessivo visualizzato: ${esito === "pos" ? "ELEVATO" : esito === "inter" ? "INTERMEDIO" : "BASSO"}`,
        ],
      };
    },
  },
];

export const RESULT_CONTENT = {
  pos: {
    title: "Sono emersi elementi compatibili",
    text: "Dal questionario sono emersi elementi compatibili con la problematica indagata. Il risultato non rappresenta una diagnosi, ma suggerisce l'opportunità di un approfondimento clinico. Ti consigliamo di rivolgerti a un professionista della salute mentale.",
  },
  inter: {
    title: "Sono emersi alcuni elementi",
    text: "Dal questionario sono emersi pochi o alcuni elementi compatibili con la problematica indagata. Il risultato non rappresenta una diagnosi. Se questi aspetti ti causano sofferenza o interferiscono con la tua vita quotidiana, ti consigliamo comunque di rivolgerti a un professionista della salute mentale.",
  },
  neg: {
    title: "Non emergono elementi significativi",
    text: "Dal questionario non emergono elementi significativi compatibili con la problematica indagata. Un test di screening non può tuttavia escludere una condizione clinica. Puoi comunque rivolgerti a un professionista della salute mentale se avverti una difficoltà o ritieni utile un approfondimento.",
  },
};

export const SCREENING_DISCLAIMER_RESULT =
  "Questo questionario è uno strumento di screening e non sostituisce una valutazione medica, psicologica o psichiatrica.";
